import searchIcon from '@/icons/search.svg';
import { InputAdornment, InputProps, TextField } from '@mui/material';

type SearchFieldProps = {
  searchTerm: string;
  setSearchTerm: (arg0: string) => void;
  placeholder?: string;
  style?: object;
};

function SearchField(props: SearchFieldProps) {
  const { searchTerm, setSearchTerm, placeholder, style } = props;
  return (
    <TextField
      size="small"
      value={searchTerm}
      onChange={(e) => setSearchTerm(e.target.value)}
      style={{
        minWidth: '50%',
        height: '32px',
        fontSize: '13px',
        ...style,
      }}
      placeholder={placeholder}
      InputProps={
        {
          endAdornment: (
            <InputAdornment position="end">
              <img src={searchIcon} alt="icone de pesquisa" />
            </InputAdornment>
          ),
          style: {
            paddingRight: '10px',
            paddingTop: '0px',
            paddingBottom: '0px',
            paddingLeft: '10px',
            fontSize: '13px',
          },
        } as InputProps
      }
    />
  );
}

export default SearchField;
